import styled, { css } from "styled-components";

export const PageCover = styled.div`
    justify-content: center;
    align-items: center;
    display: grid;
    height: 100vh;
`;

export const BoxInfo = styled.div`
    align-items: center;
    place-content: center;
    justify-content: center;
    width: 400px;
    padding: 20px;
    border: 1px solid black;

    div{
        margin: 10px;
    }
`;

export const CenterContainer = styled.div`
    align-items: center;
    place-content: center;
    justify-content: center;
    height: 300px;
    width: 400px;
    padding: 10px;
    text-align: center;

    img{
        margin-bottom: 2px; 
        height: 60px; 
        max-width: 300px;
    }
`;

export const BlockContainer = styled.div`
    padding: 10px;
    width: 100%;
`;

export const BlueSpan = styled.span`
    color: var(--blue) !important
`;

export const WrapTex = styled.h4`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow: hidden;
  white-space: normal;
`;

export const PrintStyles = css`
    .cover{
        display: none !important;
    } 
    @media print{
        @page {
            size: A4;
            margin: 10px;
            body{
                background-color: #FFF !important;
                color: #000 !important;
            }
        }
        .noPrintElement{
            display: none !important;
        }
        .cover{
            display: grid !important;
        }
        .dlAVxR li.list-component-child{
            flex-direction: initial !important;
        }
        .blTEpE li.list-component-child{
            flex-direction: initial !important;
        }
    }
`;



export default BlockContainer;
